import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { areSameCompanies } from '~/helpers/utils';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import { trackCardApplicationActions } from '~/store/actions/analyticsActions';
import {
  patchCardApplication,
  postCardApplication,
} from '~/store/actions/cardApplicationActions';

const useGoToNextStep = () => {
  const dispatch = useAppDispatch();
  const form = useSelector((state: RootState) => state.cardApplication.form);
  const currentApplicationOrganizationIdentifier = useSelector(
    (state: RootState) =>
      state.cardApplication.currentApplicationOrganizationIdentifier
  );

  const onNextStepClick = useCallback(async () => {
    dispatch(
      trackCardApplicationActions({
        actionName: 'next_button_pressed',
      })
    );

    const companyHasChanged = !areSameCompanies(
      form.organizationNumber ||
        form.creditReportProvider?.creditReportProviderNumber,
      currentApplicationOrganizationIdentifier
    );

    if (companyHasChanged) {
      await dispatch(postCardApplication({ shouldGoToNextStep: true }));
    } else {
      await dispatch(patchCardApplication({ shouldGoToNextStep: true }));
    }
  }, [
    currentApplicationOrganizationIdentifier,
    dispatch,
    form.organizationNumber,
    form.creditReportProvider?.creditReportProviderNumber,
  ]);

  return onNextStepClick;
};

export default useGoToNextStep;
